/*export interface IInteractionOptions {
	interaction : Interaction;
	element: Element;
}

export interface IInteractionRadioControlOptions extends ControlOptions {
	interactions : IInteractionOptions[];
}

export class InteractionRadioControl extends Control {
	constructor(options: IInteractionRadioControlOptions) {

		let container = document.createElement('div');
		container.className = 'interaction-radio ol-unselectable ol-control';
		let df = document.createDocumentFragment();

		options.interactions.forEach((interaction) => {
			let button = document.createElement('button');
			button.appendChild(interaction.element)
			// button.innerHTML = interaction[1];
			let theInteraction : Interaction = interaction.interaction;
			button.addEventListener('click', (ev) => {
				this.setActiveInteraction(theInteraction);
			});

			df.appendChild(button);
		});

		container.appendChild(df);

		super({ element: container });

		this.currentInteraction = null;
	}

	protected currentInteraction: Interaction;

	private setActiveInteraction(theInteraction: Interaction) {
		if (this.currentInteraction) {
			this.getMap().removeInteraction(this.currentInteraction);

		}
		this.currentInteraction = theInteraction;

		if (!theInteraction) {
			return;
		}

		this.getMap().addInteraction(theInteraction);
	}
}

export class SmapInteractionsControl extends InteractionRadioControl {
	constructor() {
		let defaultElement = document.createElement('i');
		defaultElement.className = 'icon icon-map';
		let defaultInteraction = {
			interaction: null,
			element : defaultElement
		};

		let pinIcon = document.createElement('i');
		pinIcon.className = 'icon icon-pins2';

		let addPinInteraction = {
			interaction : new Select(),
			element: pinIcon
		};

		let options = {
			interactions : [defaultInteraction, addPinInteraction]
		};
		super(options);
	}
}
*/
import {Control} from "ol/control";

export interface IIconControlOptions {
	onClick: (event: any) => void;
	iconClass : string;
	extraClasses?: string;
	title: string;
}
/*
export class IconControl extends Control {
	constructor(options: IIconControlOptions) {

		let container = document.createElement('div');
		let cls = 'ol-unselectable ol-control';
		if(options.extraClasses) {
			cls += " " + options.extraClasses;
		}

		container.className = cls;
		container.setAttribute('title', options.title);

		let df = document.createDocumentFragment();

		let button = document.createElement('button');
		button.className = options.iconClass;
		// button.innerHTML = interaction[1];
		button.addEventListener('click', options.onClick);
		df.appendChild(button);

		container.appendChild(df);

		super({ element: container });
	}
}*/

export class FabControl extends Control {
	constructor(options: IIconControlOptions) {
		let container = document.createElement('div');
		let cls = 'material-floating-button'; //  + options.iconClass;
		if(options.extraClasses) {
			cls += " " + options.extraClasses;
		}

		container.setAttribute('role', 'button');
		container.className = cls;
		container.setAttribute('title', options.title);
		container.addEventListener('click', options.onClick);

		let icon = document.createElement('i');
		icon.className = options.iconClass;
		container.appendChild(icon);

		super({ element: container });
	}
}